export default __webpack_public_path__ + "static/citrix-4b63b90f22c5e8bf12e9b568aeb52a51.svg";